module.exports = __webpack_public_path__ + "assets/img/Type BS (5).ab0d6d04.jpg";